module.exports = cfp.vendors["react@18"];